<h2 i18n="assign repeat field@@assign_rpeat_field">Assign Repeat Field</h2>
@if (formGroup) {
  <form [formGroup]="formGroup">
    <mat-form-field style="width: 45%">
      <input
        matInput
        placeholder="Field"
        formControlName="field"
        [matAutocomplete]="auto"
        />
      <mat-autocomplete #auto="matAutocomplete">
        @for (field of surveyFieldOptions | async; track field) {
          <mat-option
            [value]="field"
            >
            {{ field }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
}
<div mat-dialog-actions>
  <button
    mat-button
    [disabled]="!(field && field.length > 0)"
    [mat-dialog-close]="field"
    i18n="submit@@submit"
    >
    Submit
  </button>
  <button mat-button color="accent" (click)="onCancel()" i18n="cancel@@cancel">Cancel</button>
</div>
